<template>


    <b-card no-body>



        <div class="card-header border-0">
            <div class="row align-items-center">
                <div class="col">
                    <h3 class="mb-0">Your Pre-order sales</h3>
                </div>
                <div class="col text-right">
                    <a href="#!" class="btn btn-sm btn-dark">Something</a>
                </div>
            </div>
        </div>
        <div class="table-responsive">

            <table class="table align-items-center table-flush">
                <thead class="thead-light">
                    <tr>
                        <th scope="col">Customer</th>
                        <th scope="col">Date</th>
                        <th scope="col">Sold copies</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">
                            Test Testerson
                        </th>
                        <td>
                            12.10.2024
                        </td>
                        <td>
                            12
                        </td>
                    </tr>
                    
                    <tr>
                        <th scope="row">
                            Test Testerson
                        </th>
                        <td>
                            12.10.2024
                        </td>
                        <td>
                            12
                        </td>
                    </tr>


                    <tr>
                        <th scope="row">
                            Test Testerson
                        </th>
                        <td>
                            12.10.2024
                        </td>
                        <td>
                            12
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>



        <!-- Card image
        <img class="card-img-top" :src="currentBook.thumb" alt="Image placeholder">

        <b-card-body>
            <div class="loader" v-if="loading"></div>
            <b-card-title class="h2 mb-0">Find your presale results here</b-card-title>
            <small class="text-muted">by {{ currentBook.editor }} {{ formatDate(currentBook.updated_at) }} </small>
            <b-card-text class="mt-4">
                show sales list including amount, client name
                <br><br>

                <h4>Your presale address:</h4>
            </b-card-text>
        </b-card-body>
    -->
    </b-card>


</template>

<script>
import { mapGetters } from "vuex";
import moment from 'moment'

export default {
    name: "presale-results",
    components: {
    },
    data() {
        return {
            loading: false,
            currentBook: [],
        };
    },
    props: {
        photoBookId: '',
        hasQrCode: false,
    },
    methods: {
        retrieveBook() {
            this.loading = true;
            this.$api.getPhotoBook(this.photoBookId)
                .then((response) => {
                    console.log(response);
                    this.currentBook = response.data;
                    console.log(this.currentBook);
                })
                .catch((e) => {
                    console.log(e);
                }).finally(() => {
                    this.loading = false
                });
        },
        formatDate(date) {
            return moment(date).format("Do MMM YYYY")
        },
        async copyURL(mytext) {
            try {
                
            await navigator.clipboard.writeText(mytext);
            alert('Copied');
            } catch($e) {
            alert('Cannot copy');
            alert($e);
            }
        }
    },
    computed: {
        ...mapGetters({ currentAccount: 'currentAccount' }),
        commentsLoaded: function () {
            return this.currentBook ? true : false;
        }
    },
    mounted() {
      //  this.retrieveBook();
    },
};
</script>
<style></style>